import { InjectionToken } from '@angular/core';

import { TellentCurrentUser } from '../types';

export const ORG_GUID = new InjectionToken<string>('Authorized organization GUID');
export const BRAND = new InjectionToken<'kiwi' | 'recruitee'>(
  'Current brand in the context of the organization',
);
export const TELLENT_CURRENT_USER = new InjectionToken<TellentCurrentUser>(
  'Current user in the context of the organization',
);
